import type { ComponentProps } from 'react';

interface Props extends ComponentProps<'svg'> {
  className?: string;
}

const HubertLogo = ({ width = 240, height = 40, ...props }: Props) => {
  return (
    <svg
      {...props}
      width={width} // width="304"
      height={height} // height="155"
      viewBox="0 0 304 155"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M137.124 0H18.6312C8.7568 0 0.677734 8.07907 0.677734 17.9535V136.447C0.677734 146.321 8.7568 154.4 18.6312 154.4H137.124C146.999 154.4 155.078 146.321 155.078 136.447V17.9535C155.078 7.95083 146.999 0 137.124 0ZM77.8777 148.116C38.6365 148.116 6.83322 116.313 6.83322 77.0718C6.83322 37.8306 38.6365 6.02724 77.8777 6.02724C117.119 6.02724 148.922 37.8306 148.922 77.0718C148.922 116.313 117.119 148.116 77.8777 148.116Z"
        fill="white"
      />
      <path
        d="M232.277 148.117C271.514 148.117 303.321 116.309 303.321 77.0721C303.321 37.8353 271.514 6.02759 232.277 6.02759C193.04 6.02759 161.232 37.8353 161.232 77.0721C161.232 116.309 193.04 148.117 232.277 148.117Z"
        fill="white"
      />
    </svg>
  );
};

export default HubertLogo;
